module.exports = __webpack_public_path__ + "img/v1.5.854fbd31.jpg";